module.exports = __webpack_public_path__ + "img/95216760d8bbb34e2c65c4d4f0065872.png";


//////////////////
// WEBPACK FOOTER
// ./common/assets/images/cloud.png
// module id = 47
// module chunks = 0